import React from "react";
import { PlanEligibilityDataContainer } from "../../../containers";

const PlanEligibilityDataReport = (props) => {
  return <PlanEligibilityDataContainer {...props} />;
};

export default PlanEligibilityDataReport;
